export default "__VITE_ASSET__90bf8422__"